







import { Component, Vue } from 'vue-property-decorator';
import xiaofang from '../../../assets/image/xiaofang.png';
// 声明组件*****************
@Component
export default class Erweima extends Vue {
  // 属性*****************
    private xiaofang: string = xiaofang;
  // private type: string = 'loading';
 

  // 方法*****************

}
